// @flow

import * as React from 'react';
import ReactDOM from 'react-dom';
import { get, set } from 'lodash';

export const getRef = (Component: any, key: string): any => {
  // Regardless of whether the ref is a real DOM node or a component,
  // always return the representative DOM node.
  const ref = get(Component, ['dangerousRefs', key]);
  return ReactDOM.findDOMNode(ref);
};

export const setRef = (Component: any, key: string) => (
  nodeOrComponent: React.Node | Element
) => {
  // The ref might be a real DOM node _or_ a representation of a component
  set(Component, ['dangerousRefs', key], nodeOrComponent);
};

export const subscribeAnimationFrame = (onFrame: Function) => {
  let isListening = false;
  const listenToFrame = () => {
    requestAnimationFrame((...args) => {
      if (isListening) {
        onFrame(...args);
        listenToFrame();
      }
    });
  };
  isListening = true;
  listenToFrame();
  return () => {
    isListening = false;
  };
};
